import React from "react";
import { animateScroll as scroll } from "react-scroll";
import { sendAppEvent, setMetaThemeColor } from "../../Utils";
import { NewHomepageContainer } from "./styles";
import firebase from "../../Firebase.js";
import { Link } from "react-router-dom";
import AutoPlaySilentVideo from "../AutoPlaySilentVideo";
import SudowriteLogo from "../SudowriteLogo";
import classnames from "classnames";
import { APP_DOMAIN } from "../../../../src/shared/constants.js";

const db = firebase.firestore();

class NewHomepage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: null,
      error: false,
      charactersVisible: false,
      twistVisible: false,
      wormhole: false,
      loading: false,
      gateBeta: false,
      showCornerButton: false,
    };

    this.wormholeOptionsRef = React.createRef();
  }

  async componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  async componentDidMount() {
    let lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
      let lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            for (let source in video.target.children) {
              let videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });

      lazyVideos.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }

    setMetaThemeColor("#F5F2E4");

    window.addEventListener("scroll", this.handleScroll);

    // don't check app settings for now

    let settings = (await db.collection("appSettings").limit(1).get()).docs[0];

    if (settings) {
      this.setState({
        gateBeta: settings.get("gateBeta"),
        loading: false,
      });
    } else {
      this.setState({
        loading: false,
      });
    }

    sendAppEvent("Homepage View");
  }

  handleChange = (event) => {
    var update = {};
    update[event.target.name] = event.target.value;
    this.setState(update);
  };

  handleScroll = () => {
    if (window.scrollY > 600 && !this.state.showCornerButton) {
      this.setState({ showCornerButton: true });
    } else if (window.scrollY <= 600 && this.state.showCornerButton) {
      this.setState({ showCornerButton: false });
    }
  };

  charactersVisible = (isVisible) => {
    if (!this.state.charactersVisible && isVisible) {
      this.setState({ charactersVisible: true });
    }
  };

  twistVisible = (isVisible) => {
    if (!this.state.twistVisible && isVisible) {
      this.setState({ twistVisible: true });
    }
  };

  wormhole = (event) => {
    this.setState({ wormhole: true });
    event.preventDefault();
  };

  scrollToOptions = (event) => {
    const node = this.wormholeOptionsRef.current;
    const offsetTop = node.offsetTop;
    scroll.scrollTo(offsetTop);
  };

  scrollToElement = (element) => {
    document.querySelector(element).scrollIntoView({
      behavior: "smooth",
    });
  };
  signupButton = (style, position = "top") => {
    if (this.state.gateBeta) {
      return (
        <button
          onClick={(e) => {
            e.preventDefault();
            sendAppEvent("Click Join the Beta", { position: position });
            window.location = "https://docs.google.com/forms/d/e/1FAIpQLSf6g3-cYRorisgd2Sv3a62A4Gn2gaGQ7doLkeVapFRdP_SgnQ/viewform?entry.879531967=";
          }}
          className={style}
        >
          Apply for the Beta
        </button>
      );
    } else {
      return (
        <button
          onClick={(e) => {
            e.preventDefault();
            sendAppEvent("Click Join the Beta", { position: position });
            this.props.openLogin();
          }}
          className={style}
        >
          Try Sudowrite for free
        </button>
      );
    }
  };

  render() {
    return (
      <NewHomepageContainer>
        <div className="paper-texture"></div>
        <button
          onClick={(e) => {
            e.preventDefault();
            sendAppEvent("Click Join the Beta", { position: "corner" });
            this.props.openLogin();
          }}
          className={classnames({ "green-corner-button": true, "show-corner-button": this.state.showCornerButton })}
        >
          Try Sudowrite for free
        </button>
        <nav>
          <Link to="/">
            <SudowriteLogo
              size="large"
              opacity={0.5}
            />
          </Link>
          <ul>
            <li>
              <Link to="/FAQ">FAQ</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
            <li className="login">
              <a onClick={this.props.openLogin}>Log in</a>
            </li>
          </ul>
        </nav>
        <section
          className="light"
          id="hero-module"
        >
          <div className="content-row wide">
            <div className="content-column">
              <div className="spacer-lg shrink-on-short-viewports"></div>
              <div className="spacer-small hide-on-mobile"></div>
              <h1 className="large-header">
                <i>Sudowrite</i> is the <span className="purple">non-judgmental,</span> <br />
                always-there-to-read-<span className="orange">one-more-draft,</span> <br />
                <span className="rainbow1">never-</span>
                <span className="rainbow2">runs-</span>
                <span className="rainbow3">out-</span>
                <span className="rainbow4">of-</span>
                <span className="rainbow5">ideas</span>-even-at-
                <span className="red">
                  3<span className="smallcaps">am</span>,
                </span>
                <br />
                AI writing partner you always wanted.️
              </h1>
              <h1 className="small-header">
                The <span className="purple">non-judgmental,</span> <br />
                always-<span className="orange">available,</span> <br />
                <span className="rainbow1">willing-</span>
                <span className="rainbow2">to-</span>
                <span className="rainbow3">read-</span>
                <span className="rainbow4">30-</span>
                <span className="rainbow5">drafts</span>
                <br />
                AI writing partner you always wanted.️
              </h1>
              <div className="spacer-medium smaller-on-mobile"></div>
              {this.signupButton("green-upper-button", "top")}
              <div className="spacer-small hide-on-tablet hide-on-mobile"></div>
            </div>
          </div>
          <div className="spacer-lg"></div>
          <div className="spacer-lg shrink-on-short-viewports"></div>
          <div className="spacer-medium hide-on-mobile"></div>
        </section>
        <section
          className=""
          id="logo-module"
        >
          <div className="content-row wide">
            <p className="as-seen-in">AS SEEN IN</p>
            <div className="logos">
              <img
                src="/assets/vanity_fair_logo.png"
                alt="Vanity Fair logo"
              />
              <img
                src="/assets/The_New_York_Times.png"
                alt="New York Times logo"
              />
              <img
                src="/assets/The_New_Yorker.png"
                alt="New Yorker logo"
              />
              <img
                src="/assets/Atlantic-logo.png"
                alt="The Atlantic logo"
              />
              <img
                src="/assets/verge-logo.png"
                alt="The Verge logo"
              />
              <img
                src="/assets/The_Washington_Post.png"
                alt="Washington post logo"
              />
              <img
                src="/assets/Wired_logo.png"
                alt="Wired logo"
              />
            </div>
            <p className="as-seen-in">AS SEEN IN</p>
          </div>
          <div className="spacer-medium"></div>
        </section>
        <div id="product-module">
          <section className="light">
            <div className="spacer-lg"></div>
            <h2 className="jumbo-header">Blank page, begone!</h2>
            <div className="spacer-lg"></div>
            <div className="content-row reverse-order-when-vertical">
              <div className="content-column">
                <h2 className="feature-header">Get a page of words in less time than it takes to make your&nbsp;coffee.</h2>
                <p className="feature-body">
                  Type in a concept and <strong>First Draft</strong> will generate up to 1000 words, getting the ball rolling so you can get in the&nbsp;groove.
                </p>
              </div>
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-First-Draft.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-First-Draft.mp4"
                poster="/assets/videos/RC1-First-Draft_2x.png"
                className="lazy"
              />
            </div>
            <div className="spacer-xl"></div>
            <div className="content-row">
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Write.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Write.mp4"
                poster="/assets/videos/RC1-Write_2x.png"
                className="lazy"
              />
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <div className="content-column">
                <h2 className="feature-header thinner">
                  When the words just won’t come out – <strong>Write</strong> can do it for&nbsp;you
                </h2>
                <p className="feature-body">
                  <strong>Write</strong> is like autocomplete on steroids. It analyzes your characters, tone, and plot arc and generates the next 300 words in your voice. It even gives
                  you&nbsp;options!
                </p>
              </div>
            </div>
            <div className="spacer-xl"></div>
            <div className="content-row reverse-order-when-vertical">
              <div className="content-column">
                <h2 className="feature-header wider wider-on-tablet">Descriptions that paint a picture in the mind, without bogging down the&nbsp;story.</h2>
                <p className="feature-body wider-on-mobile tighter-on-tablet">
                  If you only focus on action and dialogue, writing can feel flat. <strong>Describe</strong> makes it easy to help your readers connect to your characters and feel like they’re
                  really&nbsp;“there”.
                </p>
              </div>
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Describe.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Describe.mp4"
                poster="/assets/videos/RC1-Describe_2x.png"
                className="lazy"
              />
            </div>
            <div className="spacer-xl"></div>
            <div className="content-row">
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Rewrite.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Rewrite.mp4"
                poster="/assets/videos/RC1-Rewrite_2x.png"
                className="lazy"
              />
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <div className="content-column">
                <h2 className="feature-header wider-on-tablet even-wider-on-mobile">You could rewrite the same sentence 100 times... or you could make the computer do&nbsp;it.</h2>
                <p className="feature-body">
                  <strong>Rewrite:</strong> the super-flexible, infinitely-tenacious revision buddy who always takes direction (and doesn’t have&nbsp;an&nbsp;ego!)
                </p>
              </div>
            </div>
            <div className="spacer-xl"></div>
          </section>
          {/* <section className="dark">
            <div className="paper-texture"></div>
            <div className="spacer-lg"></div>
            <h2 className="jumbo-header">
              Everyone knows it’s <br className="disappear-on-mobile" />
              10% writing and 90%&nbsp;editing
            </h2>
            <div className="spacer-lg"></div>
            <div className="content-row reverse-order-when-vertical">
              <div className="content-column">
                <h2 className="feature-header wider-on-tablet even-wider-on-mobile">You could rewrite the same sentence 100 times... or you could make the computer do&nbsp;it.</h2>
                <p className="feature-body">
                  <strong>Rewrite:</strong> the super-flexible, infinitely-tenacious revision buddy who always takes direction (and doesn’t have&nbsp;an&nbsp;ego!)
                </p>
              </div>
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Rewrite.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Rewrite.mp4"
                poster="/assets/videos/RC1-Rewrite_2x.png"
                className="lazy"
              />
            </div>
            <div className="spacer-xl"></div>
            <div className="content-row">
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Feedback.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Feedback.mp4"
                poster="/assets/videos/RC1-Feedback_2x.png"
                className="lazy"
              />
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <div className="content-column">
                <h2 className="feature-header slightly-wider wider-on-tablet">
                  Need an extra pair of eyes? Sudowrite never sleeps, has read a million stories, and can read yours in 10&nbsp;seconds.
                </h2>
                <p className="feature-body">
                  <strong>Feedback</strong> gives you three actionable areas to improve. It won’t complain if you make it read 36 drafts, and you’ll never hurt its&nbsp;feelings.
                </p>
              </div>
            </div>
            <div className="spacer-xl"></div>
            <div className="content-row reverse-order-when-vertical">
              <div className="content-column">
                <h2 className="feature-header">Find the perfect word, every time.</h2>
                <p className="feature-body">How many clicks does it take to get to the center of a good sentence? Two!</p>
              </div>
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Related-Words.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Related-Words.mp4"
                poster="/assets/videos/RC1-Related-Words_2x.png"
                className="lazy"
              />
            </div>
            <div className="spacer-xl"></div>
          </section>
          <section className="light">
            <div className="spacer-lg"></div>
            <h2 className="jumbo-header">Planning makes it perfect</h2>
            <div className="spacer-medium"></div>
            <div className="spacer-small"></div>
            <div className="content-row reverse-order-when-vertical">
              <div className="content-column">
                <h2 className="feature-header wider-on-small-tablet">Explore plot points, character arcs, and themes in a magic AI&nbsp;canvas.</h2>
                <p className="feature-body">
                  <strong>Canvas</strong> will generate alternate plot points, character secrets, and plot twists with you. Hoard all your inspiration and references in one&nbsp;place.
                </p>
              </div>
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Canvas.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Canvas.mp4"
                poster="/assets/videos/RC1-Canvas_2x.png"
                className="lazy"
              />
            </div>
            <div className="spacer-lg"></div>
            <div className="content-row">
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Brainstorm.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Brainstorm.mp4"
                poster="/assets/videos/RC1-Brainstorm_2x.png"
                className="lazy"
              />
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <div className="content-column">
                <h2 className="feature-header">Find the perfect name, magic item, or&nbsp;title.</h2>
                <p className="feature-body">
                  <strong>Brainstorm:</strong> the infinite “yes, and” buddy that never runs out of ideas. Thumbs up your favorites and it’ll learn and give you better&nbsp;ones.
                </p>
              </div>
            </div>
            <div className="spacer-lg"></div>
            <div className="content-row reverse-order-when-vertical">
              <div className="content-column">
                <h2 className="feature-header wider-on-tablet">Bringing it to life is easier when you can see&nbsp;it.</h2>
                <p className="feature-body">
                  <strong>Visualize</strong> brings your character sheets and worldbuilding documents to life with art generated from your&nbsp;descriptions.
                </p>
              </div>
              <div className="spacer-lg medium-on-tablet smaller-on-mobile"></div>
              <AutoPlaySilentVideo
                webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Visualize.webm"
                mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/RC1-Visualize.mp4"
                poster="/assets/videos/RC1-Visualize_2x.png"
                className="lazy"
              />
            </div>
            <div className="spacer-xl"></div>
          </section>
          <section className="dark feel-like-home">
            <div className="paper-texture"></div>
            <div className="spacer-lg"></div>
            <h2 className="jumbo-header">A writing app should feel like home</h2>
            <div className="spacer-medium"></div>
            <div className="content-row">
              <div className="content-column">
                <img src="/assets/dark-modes.png" alt="dark mode" id="dark mode" />
                <p className="feature-caption">We have six dark modes you can choose from</p>
              </div>
              <div className="spacer-small"></div>

              <div className="content-column">
                <img src="/assets/focus-mode.png" alt="full screen" id="full screen" />
                <p className="feature-caption">Go full screen on focus mode to keep distractions away</p>
              </div>
              <div className="spacer-small"></div>

              <div className="content-column">
                <img src="/assets/folders.png" alt="organization" id="organization" />
                <p className="feature-caption">Organize your drafts and chapters neatly within your projects</p>
              </div>
            </div>
            <div className="spacer-lg"></div>
          </section> */}
        </div>
        {/* <section className="light" id="ai-101">
          <div className="spacer-lg"></div>
          <div className="content-column header-section">
            <h2 className="jumbo-header">AI 101</h2>
            <h3>A deep dive on how Sudowrite writes 14,000 unique pieces of prose per day without plagiarizing</h3>
          </div>
          <div className="spacer-lg"></div>
          <div className="content-row">
            <img src="/assets/AI-101-1.png" alt="brainstorm" />
            <div className="spacer-lg smaller-on-mobile"></div>
            <div className="content-column">
              <p className="body">
                Sudowrite is based on GPT-3, a <strong>175 billion parameter</strong> Transformer model, which learns general concepts from its training data. The bigger the model, the more complex
                these concepts can&nbsp;be.
                <br />
                <br />
                The model generates text by guessing what's most likely to come next, one word at a time. Kind of like autocomplete on your phone. It’s not copying and pasting sentences from a
                database. It actually writes each word&nbsp;individually.
              </p>
            </div>
          </div>
          <div className="spacer-lg"></div>
          <div className="content-row reverse-order-when-vertical">
            <div className="content-column">
              <p className="body">
                Since each passage is generated one word at a time, it’s highly unlikely Sudowrite would choose the same word dozens or hundreds of times in a row. The first word or two might be
                similar, but the further you get from the starting point, the more unique the text&nbsp;becomes.
              </p>
            </div>
            <div className="spacer-lg smaller-on-mobile"></div>
            <img src="/assets/AI-101-2.png" alt="brainstorm" />
          </div>
          <div className="spacer-lg"></div>
          <div className="content-row">
            <AutoPlaySilentVideo
              webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/ai-101-pt3-v2.webm"
              mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/homepage/ai-101-pt3-v2.mp4"
              poster="/assets/videos/ai-101-pt3-v2_2x.png"
              className="lazy"
            />
            <div className="spacer-lg smaller-on-mobile"></div>
            <div className="content-column">
              <p className="body">
                “But does it really never plagiarize? I want to run a test where I make it&nbsp;plagiarize.” <br />
                <br /> Sudowrite is for <strong>creating your own original writing</strong>, but yes, you can force Sudowrite to plagiarize if you try. Here’s&nbsp;how… <br />
                <br /> Paste in the first paragraph of Harry Potter*, and Sudowrite will confidently output the second paragraph. That’s because the second paragraph of Harry Potter exists in many
                places in the web, like book reviews, and Sudowrite assumes you have the best&nbsp;intentions. <br />
                <br /> But start with your own work, and you’ll only get completely original&nbsp;suggestions. <br />
                <br /> * Don’t do this. It’s against our <a href="https://sudowrite.notion.site/Terms-and-Conditions-83ddd78e1ab04d9d88321a9ef7665925">terms of service</a> to use Sudowrite to
                plagiarize.
              </p>
            </div>
          </div>
          <div className="spacer-lg"></div>
        </section>
        <section className="dark" id="extension">
          <div className="paper-texture"></div>
          <div className="spacer-lg"></div>
          <div className="content-row wide">
            <img id="extension-screenshot" src="/assets/chrome-extension.png" alt="sudowrite extension screenshot" />
            <div className="spacer-medium smaller-on-mobile"></div>
            <div className="content-column">
              <h2>
                Prefer writing in Google Docs? <br />
                The World’s Best Creative Writing AI is available there,&nbsp;too.
              </h2>
              <div className="spacer-small smaller-on-mobile"></div>
              <button>
                <a href="https://chrome.google.com/webstore/detail/sudowrite-ai-fiction-writ/llfifnhohhnmdojjdllnpmnljfnfkobo" target="_blank">
                  Install our Chrome extension
                </a>
              </button>
            </div>
            <div className="spacer-lg hide-on-mobile hide-on-tablet"></div>
          </div>
          <div className="spacer-lg"></div>
        </section> */}
        <section
          className="light"
          id="testimonials-module"
        >
          <div className="spacer-lg"></div>
          <div className="content-row">
            <h2>Look mom, we’re famous!</h2>
          </div>
          <div className="spacer-lg medium-on-mobile"></div>
          <div
            className="content-row"
            id="newspaper-quotes"
          >
            <div className="quote-canvas">
              <div
                className="quote"
                id="nyt-quote"
              >
                <p>The A.I. was coming up with impressively cogent paragraphs of analysis — some, frankly, better than what I could have generated</p>
                <img
                  src="/assets/Speech_bubble_point.svg"
                  className="speech-bubble-point"
                  id="nyt-bubble-point"
                  alt=""
                />
                <div
                  className="caption-column"
                  id="nyt-caption"
                >
                  <img
                    src="/assets/The_New_York_Times.png"
                    alt="NYT logo"
                  />
                  <p className="caption">Kevin Roose · Nov, 2021 </p>
                </div>
              </div>
              <div
                className="quote"
                id="washpo-quote"
              >
                <p>For writers who don’t like writing—which, in my experience, is nearly all of us— Sudowrite may well be a salvation.</p>
                <img
                  src="/assets/Speech_bubble_point.svg"
                  className="speech-bubble-point"
                  id="washpo-bubble-point"
                />
                <div
                  className="caption-column"
                  id="washpo-caption"
                >
                  <img
                    src="/assets/The_New_Yorker.png"
                    alt="The New Yorker logo"
                  />
                  <p className="caption">Stephen Marche · Apr, 2021</p>
                </div>
              </div>
              <div
                className="quote"
                id="new-yorker-quote"
              >
                <p>... it even convinced journalism legend Gay Talese it could imitate him</p>
                <img
                  src="/assets/Speech_bubble_point.svg"
                  className="speech-bubble-point"
                  id="new-yorker-bubble-point"
                />
                <div
                  className="caption-column"
                  id="new-yorker-caption"
                >
                  <img
                    src="/assets/The_Washington_Post.png"
                    alt="The Washington Post logo"
                  />
                  <p className="caption">Steven Zeitchik · Nov, 2021 </p>
                </div>
              </div>
            </div>
          </div>
          <div className="spacer-lg"></div>
          <div className="spacer-medium"></div>
          <div
            className="content-row"
            id="author-header"
          >
            <h3>These people don’t have logos, but they’re pretty smart too</h3>
          </div>
          <div className="spacer-medium"></div>
          <div className="content-row">
            <div className="quote-canvas-authors">
              <div className="content-row">
                <div className="content-column">
                  <img
                    className="portrait"
                    src="/assets/John_August.png"
                    alt="John August"
                  />
                  <div
                    className="quote-mini"
                    id="John-quote"
                  >
                    <p>It really does feel like magic.</p>
                    <img
                      src="/assets/Speech_bubble_point.svg"
                      className="speech-bubble-point"
                      id="John-bubble-point"
                    />
                  </div>
                  <div className="spacer-smaller"></div>
                  <p className="author-name">John August</p>
                  <p className="author-bio">Writer of Go, Big Fish, and Arlo Finch</p>
                </div>
                <div className="spacer"></div>
                <div className="content-column">
                  <img
                    className="portrait"
                    src="/assets/Hugh_Howey.png"
                    alt="Hugh Howey"
                  />
                  <div
                    className="quote-mini"
                    id="Hugh-quote"
                  >
                    <p>It’s scary good.</p>
                    <img
                      src="/assets/Speech_bubble_point_tall.svg"
                      className="speech-bubble-point"
                      id="Hugh-bubble-point"
                    />
                  </div>
                  <div className="spacer-smaller"></div>
                  <p className="author-name">Hugh Howey</p>
                  <p className="author-bio">Bestselling author of “WOOL”</p>
                </div>
                <div className="spacer"></div>
                <div className="content-column">
                  <img
                    className="portrait"
                    src="/assets/April_Henry.png"
                    alt="April Henry"
                  />
                  <div
                    className="quote-mini"
                    id="April-quote"
                  >
                    <p>
                      It allows me to write faster <u>and</u> better!
                    </p>
                    <img
                      src="/assets/Speech_bubble_point.svg"
                      className="speech-bubble-point"
                      id="Mark-bubble-point"
                    />
                  </div>
                  <div className="spacer-smaller"></div>
                  <p className="author-name">April Henry</p>
                  <p className="author-bio">NYT-Bestselling author of 27&nbsp;novels</p>
                </div>
              </div>
            </div>
          </div>
          <div className="spacer-lg"></div>
        </section>
        <section
          className="dark"
          id="cta-module"
        >
          <div className="paper-texture"></div>
          <div className="spacer-lg"></div>
          <div className="content-row wide">
            <img
              className="blur"
              src="/assets/blur.png"
              alt="blur"
            />
            <img
              id="hero-2"
              src="/assets/Wormhole-UI-Sample-2.png"
              alt="sudowrite-product-cover"
            />
            <div className="content-column">
              <h2 className="trial-copy">Fall in love with writing all over again.</h2>
              <div className="spacer-small smaller-on-mobile"></div>
              <div
                className="content-row use-margin-zero"
                id="cta-button-lockup"
              >
                {this.signupButton("green-lower-button", "bottom")}
                <div className="spacer-small"></div>
                <p>$10/month after free trial. Cancel any time. No credit card needed.</p>
              </div>
            </div>
            <div className="spacer-lg hide-on-mobile hide-on-tablet"></div>
          </div>
          <div className="spacer-lg"></div>
        </section>
        <section
          className="light"
          id="manifesto-module"
        >
          <div className="spacer-lg"></div>
          <div className="content-row">
            <h3 className="manifesto-header">Who’s behind this?</h3>
            <div className="spacer-small"></div>
            <p id="origin-story">
              Our founders are writers{" "}
              <a
                href="http://www.amitgupta.com/"
                target="_blank"
              >
                Amit Gupta
              </a>{" "}
              and{" "}
              <a
                href="https://www.jamesyu.org/"
                target="_blank"
              >
                James&nbsp;Yu
              </a>
              . <br />
              <br />
              Our investors include the founders of Twitter, Medium, Gumroad, Rotten Tomatoes, WordPress and the writers/directors of Big Fish, Aladdin, Bourne Ultimatum, Oceans Twelve, and
              many&nbsp;more.
              <br />
              <br /> We’re in this because we believe in the power of&nbsp;storytelling.
            </p>
          </div>
          <div className="spacer-lg"></div>
        </section>
        <section
          className="dark"
          id="footer-module"
        >
          <div className="paper-texture"></div>
          <div className="spacer-lg"></div>
          <div
            className="content-row"
            id="sitemap"
          >
            <SudowriteLogo
              className="logo"
              size="medium"
              style={{ color: "#fff" }}
            />
            <div className="spacer-small"></div>
            <div className="spacer-small hide-on-mobile-lg"></div>
            <div className="spacer-small hide-on-mobile-lg"></div>
            <div
              className="content-column"
              id="product"
            >
              <p className="footer-header">Product</p>
              <p className="footer-item">
                <a
                  target="_blank"
                  href="https://feedback.sudowrite.com/changelog/"
                >
                  Changelog
                </a>
              </p>
              <p
                className="footer-item"
                style={{ cursor: "pointer" }}
                onClick={() => this.scrollToElement("#testimonials-module")}
              >
                Testimonials
              </p>
              <p
                className="footer-item"
                style={{ cursor: "pointer" }}
                onClick={() => this.scrollToElement("#cta-module")}
              >
                Try Sudowrite
              </p>
              <p className="footer-item">
                <a href="/FAQ">FAQ</a>
              </p>
              <p className="footer-item">
                <a
                  href="https://chrome.google.com/webstore/detail/sudowrite-ai-fiction-writ/llfifnhohhnmdojjdllnpmnljfnfkobo"
                  tatget="_blank"
                  rel="noreferrer"
                >
                  Chrome Extension
                </a>
              </p>
            </div>
            <div
              className="spacer-small"
              id="social"
            ></div>
            <div className="content-column">
              <p className="footer-header">Connect</p>
              <p className="footer-item">
                <a
                  href="https://blog.sudowrite.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Blog
                </a>
              </p>
              <p className="footer-item">
                <a href="https://sudowrite.notion.site/Sudowrite-Affiliate-Program-12788b26b71746f2a72cd05b7087e8c9">Affiliates</a>
              </p>
              <p className="footer-item">
                <a href="mailto:hi@sudowrite.com">Contact Us</a>
              </p>
              <p className="footer-item">
                <a
                  href="https://twitter.com/sudowrite"
                  target="_blank"
                >
                  Twitter
                </a>
              </p>
            </div>
            <div className="spacer-small hide-on-mobile-lg"></div>
            <div
              className="content-column"
              id="legal"
            >
              <p className="footer-header">Legal</p>
              <p className="footer-item">
                <a
                  href="https://sudowrite.notion.site/Terms-and-Conditions-83ddd78e1ab04d9d88321a9ef7665925"
                  target="_blank"
                >
                  Terms and Conditions
                </a>
              </p>
              <p className="footer-item">
                <a
                  href="https://sudowrite.notion.site/Privacy-Policy-710e53e814f8491b8ee2634ee9162ed8"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
          <div className="spacer-small"></div>
          <div className="spacer-small hide-on-desktop"></div>
          <div className="content-row">
            <p className="footer-item">
              🚀 We're hiring&nbsp;
              <a href="https://sudowrite.notion.site/We-re-hiring-engineers-and-a-community-manager-to-make-writing-magical-389c57f5ae3a421d8f8c0b48c8407e88">
                <u>engineers</u>
              </a>
              &nbsp;and a&nbsp;
              <a href={`https://${APP_DOMAIN}/jobs-community/`}>
                <u>community lead</u>
              </a>
              !
            </p>
          </div>
          <div className="spacer-lg smaller-on-mobile"></div>
        </section>
      </NewHomepageContainer>
    );
  }
}

export default NewHomepage;
